export default __webpack_public_path__ + "static/media/Booking.a683bbff.svg";